import RestService from '../services/rest';

async function createRecommended({
  productId, categoryId
}) {
  return RestService.postAuthenticated('panel/recommendeds/create', {
    productId, categoryId
  });
}

async function updateRecommended({
  id, productId, categoryId
}) {
  return RestService.putAuthenticated('panel/recommendeds/update', {
    id, productId, categoryId
  });
}

async function getRecommendeds(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/recommendeds?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function removeRecommended(id) {
  return RestService.deleteAuthenticated('panel/recommendeds/remove', { id });
}

async function getCsvRecommendedsReport() {
  const response = await RestService.getAuthenticated('panel/recommendeds/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'recommendeds-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvRecommendedModel() {
  const response = await RestService.getAuthenticated('panel/recommendeds/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Promoções CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvRecommendeds(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/recommendeds/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  createRecommended,
  getRecommendeds,
  removeRecommended,
  updateRecommended,
  getCsvRecommendedsReport,
  getCsvRecommendedModel,
  uploadCsvRecommendeds,
};
